import React from 'react';
import "../css/Projects.scss";
import { motion } from "framer-motion"
const ProjectCard = ({projectImg,appTitle,appDesc}) => {
  const motionStyle ={ 
    initial:{
      opacity:0,
      overflow:'hidden',
      x:-100,
    },
    whileInView:{
      opacity:1,
      x:0,
    },
  }
  return (
    <motion.div {...motionStyle}  className="projectCard">
      <div className="appimg"><img src={projectImg} alt="news logo" /></div>
      <div className="contentCard">
      <h1>{appTitle}</h1>
      <div className="projectDesc">
        <p>{appDesc}</p>
      </div>
      </div>
      {/* <div className="searchDiv"><button><i class="fa-solid fa-magnifying-glass"></i>More Details</button></div> */}
    </motion.div>
  )
}

export default ProjectCard;